import React from 'react';
import './App.css';
import Footer from './components/sections/Footer/footer';
import Header from './components/sections/header/header';
import Routes from './routes/routes';

function App() {


  return (
    <>
      <Routes />
      <Footer />
    </>

  );
}

export default App;
/*

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter as Router } from "react-router-dom";
import App from './App';

import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <Router><App /></Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();



*/
